<template lang="html">
    <div class="row product-dtl">
        <div class="col-sm-4 d-flex flex-column">
            <label>Product:</label>
            <span class="darker bold">{{reservation.event.product.name}}</span>
        </div>

        <div class="col-sm-8 d-flex flex-column">
            <label>Date / Time:</label>
            <span class="darker bold">{{ reservationDate }} ({{eventDuration}})</span>
        </div>

        <div class="col-sm-4 d-flex flex-column">
            <label>Location:</label>
            <span class="darker bold" v-if="reservation.event.location">{{reservation.event.location}}</span>
        </div>

        <div class="col-sm-8 d-flex flex-column">
            <label>Resource{{reservation.event.eventResources.length > 1? 's':''}}:</label>
            <v-select
                class="compact-dropdown-reservation-recourses w-100"
                :class="{'notAllowed': isResourceDropdownDisabled}"
                :disabled="isResourceDropdownDisabled"
                :options="resourcesWithAvailability"
                label="name"
                :value="getResourceName"
                @input="updateSelectedResource($event)">
            </v-select>
        </div>

        <div class="d-flex justify-content-end align-items-baseline pr-3 w-100 view-evt">
            <div class="pointer" @click.prevent="viewEvent">
                <span class="view-event-link">View Event</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { reservationsMixin } from '@/mixins/reservations'
    import { calendarEventSelectionMixin } from '@/mixins/calendarEventSelection'
    import { mapActions } from "vuex"

    import $ from "jquery"
    import extendedVSelect from '@/extends/vue-select'
    import { showLoadingEventToast } from '@/utils/loadingEventToast'

    export default {
        mixins: [
            reservationsMixin,
            calendarEventSelectionMixin,
        ],
        props: {
            reservation: {
                type: Object
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            reservationDate() {
                return this.formatDateDots(this.reservation.eventDate)+' '+this.formatTime(this.reservation.eventDate);
            },
            eventDuration() {
                let start = moment(this.reservation.event.start);
                let end = moment(this.reservation.event.end);
                let durationSeconds = end.diff(start, 'seconds');
                let momentDuration = moment.utc(durationSeconds * 1000);
                
                return momentDuration.format("HH") + 'h' + momentDuration.format("mm");
            },
            getResourceName() {
                if (!this.reservation || !this.reservation.selectedResource || !this.reservation.event) return "No Resource";

                const resource = this.reservation.selectedResource;
                const availabilityType = this.reservation.event.availabilityType;

                if (availabilityType === 1) return resource.name;

                return `${resource.name} (${resource.capacityAvailable})`;
            },
            isResourceDropdownDisabled() {
                if (this.disabled || this.accessPermissionFilter(['restricted'])) return true;

                const resources = this.reservation.event.eventResources;
                const selected = this.reservation.selectedResource;

                if (resources.length === 0) return true;

                if (
                    resources.length === 1 &&
                    selected &&
                    selected.id === resources[0].id
                ) {
                    
                    return true;
                }

                return false;
            }
        },
        methods: {
            ...mapActions([
                "updateSelectedEvent",
                "closeModal",
                "downloadGenderPricePerChannel",
                "updateSidebar",
            ]),
            async viewEvent() {
                const targetRoute = {
                    name: 'calendarExpandedWithEventId',
                    params: {
                        currentView: 'day',
                        expandedDay: this.reservation.event.start.substring(0, 10),
                        eventID: this.reservation.event.id
                    }
                };

                const waitingTime = 4000;
                showLoadingEventToast(this, { duration: waitingTime });

                await this.$router.push(targetRoute);

                    this.updateSidebar(this.reservation.event.start.substring(0, 10));
                    await this.updateSelectedEvent(this.reservation.event.id);
                    this.downloadGenderPricePerChannel(this.reservation.event.id);
                    this.closeModal();
                
                    // Toggle selected calendar event
                    $(".fc-event").removeClass("selected");
                    $(this).addClass("selected");
                    
                    // Animate side panels
                    $(".events").addClass("showingMore overflow-y-auto");
                    $(".events .list").addClass("moved-left");
                    $(".events .more").removeClass("moved-right");
            },
            updateSelectedResource: function(val) {
                const resourceName = val.name.split(' (')[0];
                const updatedResource = { ...val, name: resourceName };
                this.$set(this.reservation, 'selectedResource', updatedResource);
            }
        },
        components: {
            vSelect: extendedVSelect
        }
    }
</script>

<style lang="scss">
    @import '~@/assets/scss/_variables.scss';
    @import '~@/assets/scss/_utility.scss';

    .product-dtl label { color: #5f667c; }

    .row.product-dtl .compact-dropdown-reservation-recourses {
        max-height: fit-content;

        .dropdown-toggle {
            height: 2rem;

            .vs__actions {
                top: 0.4375rem;
            }

            .selected-tag, & input[type=search] {
                height: 1.9rem;
                margin: 0;
                font-size: 0.7rem;
                line-height: 1.4rem;
            }
        }

        .dropdown-menu {
            font-size: 0.6875rem;
            padding: 0;

            li[role=option] a {
                padding-left: 0.9375rem;
            }
        }

        .open-indicator {
            height: 0.875rem;
        }
    }

    .view-evt { margin-top: -0.125rem; z-index: 2; }

    .view-event-link {
        font-size: 0.625rem;
        color: #222c3c;
    }
</style>



// WEBPACK FOOTER //
// eventDetails.vue?89cdb1ba